/* script */
//
//
//
//
//
//

// Utils
import { isNil, omit } from 'lodash';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';

const __vue_script__ = {
    name: 'EmailTemplatePicker',

    components: { BaseSelect },

    extends: BaseControl,

    props: {
        showNoSend: {
            type: Boolean,
            default: false
        },

        eventId: {
            type: String,
            required: true
        },

        value: {
            type: String,
            default: null
        },

        templates: {
            type: Array,
            default: null // not an error
        },

        openDirection: {
            type: String,
            default: null
        },

        hintAfterLabel: {
            type: Boolean,
            default: false
        },

        defaultValue: {
            type: Object,
            default: null
        },

        loadInactive: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        },

        userIsUnsubscribed: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            innerTemplates: [],
            unsubscribedWarningText: this.$t('emailing.actions.send_email_unsubscribed_warning', [this.$utils.links.getLinkUrl('email_type')])
        };
    },

    computed: {
        /** @returns {object} */
        attrs() {
            return omit(this.$props, ['eventId', 'templates', 'showNoSend']);
        },

        innerValue: {
            /** @return {string} */
            get() {
                return this.emailTemplates.find(t => this.value === t.value);
            },

            /** @param {object} option */
            set(option) {
                this.$emit('input', option ? option.value : undefined);
            }
        },

        emailTemplates() {
            const emailTemplates = this.innerTemplates.filter(template => !this.userIsUnsubscribed || template.email_type === 'transactional')
                .map(template => ({ value: template.fp_ext_id, label: template.template_name || template.subject }));

            if (this.showNoSend) {
                emailTemplates.unshift({ value: null, label: this.$i18n.t('email_templates.do_not_send') });
            }
            return emailTemplates;
        }
    },

    watch: {
        templates: {
            immediate: true,
            handler(templates) {
                this.innerTemplates = templates || [];
                if (isNil(templates)) {
                    this.loadTemplates();
                }
            }
        }
    },

    methods: {
        async loadTemplates() {
            try {
                if (this.innerTemplates.length > 0) return;
                this.innerTemplates = await this.$services.emails.getEmailTemplates(this.eventId, { onlyActive: !this.loadInactive, cached: true });
            } catch (error) {
                console.error('[EmailTemplatePicker] An error occurred:', error.message);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-select",
    _vm._b(
      {
        staticClass: "email-template-picker",
        attrs: {
          options: _vm.emailTemplates,
          "allow-empty": _vm.showNoSend,
          disabled: _vm.disabled,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "after-label",
              fn: function (ref) {
                return [
                  _vm._t("after-label"),
                  _vm.userIsUnsubscribed
                    ? _c("div", {
                        staticClass: "alert alert-warning",
                        domProps: {
                          innerHTML: _vm._s(_vm.unsubscribedWarningText),
                        },
                      })
                    : _vm._e(),
                ]
              },
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.innerValue,
          callback: function ($$v) {
            _vm.innerValue = $$v
          },
          expression: "innerValue",
        },
      },
      "base-select",
      _vm.attrs,
      false
    )
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/pickers/EmailTemplatePicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__